export default __webpack_public_path__ + "media/images/main/r-d4d6bd1e384fe4e572cbbe6a9f85b3c6.png";